import type { Step } from "react-joyride";

export const dashboardTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບ Sunlower Supplies! ແຜງຄວບຄຸມສະແດງຕົວເລກວັນນີ້, ພາບລວມ 7 ວັນ, ສິ່ງຕ້ອງເຮັດ ແລະ ອໍເດີ້ມື້ນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="dashboard-stats"]',
    content:
      "ຕົວເລກສຳຄັນ: ອໍເດີ້ມື້ນີ້, ລໍຖ້າແພັກ, ພ້ອມສົ່ງ ແລະ ສິນຄ້າໃກ້ໝົດ — ກົດເພື່ອໄປໜ້າລາຍລະອຽດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="dashboard-reports-overview"]',
    content:
      "ພາບລວມຮ້ານ 7 ວັນ — ຍອດຂາຍ, ກຳໄລ, ຄລັງ, ຕີກັບ ແລະ ລູກຄ້າ. ກົດເພື່ອເຂົ້າລາຍງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="dashboard-quick-actions"]',
    content: "ປຸ່ມດ່ວນ: ສ້າງອໍເດີ້, ເຂົ້າຈັດສົ່ງ, ຈັດການສິນຄ້າ ແລະ ຂໍ້ຄວາມແຊດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="dashboard-recent-orders"]',
    content: "ອໍເດີ້ທີ່ສ້າງໃນມື້ນີ້ — ກົດເພື່ອເຂົ້າໄປໜ້າລາຍລະອຽດອໍເດີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="sidebar-sales"]',
    content: "ເມນູການຂາຍ: ສ້າງອໍເດີ້, ລາຍການອໍເດີ້, ຈັດສົ່ງ ແລະ ຂໍ້ຄວາມແຊດ.",
    placement: "right",
  },
];
